import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import { withGoogleMaps } from '../../contexts/google-maps-context';

import type { GoogleMaps } from '@shared/types/client-side-params';

import STYLES from './StaticMaps.module.scss';

const cls = cssModules(STYLES);

type Props = {
  googleMaps: GoogleMaps;
  overrideMapUrls?: string[]; // For CSR Client Side to update the urls
  small?: boolean;
  hasBorderRadius?: boolean;
  altText?: string;
};

const StaticMaps = ({
  altText = '',
  googleMaps,
  hasBorderRadius = false,
  overrideMapUrls,
  small = false,
}: Props) => {
  const mapUrls = overrideMapUrls || googleMaps.staticMapsUrls;

  if (!mapUrls?.length) {
    return null;
  }

  return (
    <img
      src={mapUrls[0]}
      srcSet={mapUrls.map((url, index) => `${url} ${index + 1}x`).join()}
      alt={altText}
      className={cls(
        STYLES.StaticMaps__image,
        small && STYLES.StaticMaps__smallImage,
        hasBorderRadius && STYLES.StaticMaps__borderRadius,
      )}
    />
  );
};

export default withGoogleMaps(StaticMaps);
